// extracted by mini-css-extract-plugin
export default {"hotelFacilitiesContainer":"hotel_facilities_section_hotelFacilitiesContainer__2zrCs"};